import { getEnevelopeCompletedBySelf } from '@util/CommonServicess'

const getEnvelopData = (enevlopList: any, filterData: any): any => {
    const response: any = []

    let envelops =
        enevlopList && enevlopList.length > 0
            ? enevlopList.map((item: any) => {
                  const isAborted = !!item.state?.aborted
                  const isCompleted = !isAborted && item.completed
                  const noRejected = item.state?.documents?.filter((doc: any) => doc.rejected).length
                  const isRejected = !!(noRejected > 0 && item.state?.documents.length === noRejected)
                  const showActionLink =
                      (!isAborted && !isRejected && item.actionLink && !getEnevelopeCompletedBySelf(item.state)) ||
                      isCompleted

                  const fullyCompleted = showActionLink && isCompleted
                  const pendingYourAction = showActionLink && !isCompleted && !getEnevelopeCompletedBySelf(item.state)
                  const pendingFromOthers = !showActionLink

                  return {
                      ...item,
                      isAborted,
                      isCompleted,
                      noRejected,
                      isRejected,
                      showActionLink,
                      fullyCompleted,
                      pendingYourAction,
                      pendingFromOthers,
                  }
              })
            : []

    // remove Aborted and Expired from enevelop list
    envelops = envelops.filter((item: any) => !item.isAborted && !item.state.expired)

    if (!filterData.completed && !filterData.pendingOthers && !filterData.pending && !filterData.rejected) {
        response.push(...envelops)
    } else {
        if (filterData.completed) {
            response.push(...envelops.filter((item: any) => item.fullyCompleted === true))
        }
        if (filterData.pendingOthers) {
            response.push(...envelops.filter((item: any) => item.pendingFromOthers === true))
        }
        if (filterData.pending) {
            response.push(...envelops.filter((item: any) => item.pendingYourAction === true))
        }
        if (filterData.rejected) {
            response.push(...envelops.filter((item: any) => item.isRejected === true))
        }
    }

    return response.length ? response.sort((a: any, b: any) => (a.publishDate > b.publishDate ? 1 : -1)).reverse() : []
}

export { getEnvelopData }
